<div class="price-on-card">
  <span class="prefix" [class.custom-order]="this.currency === CurrencyEnum.JPY">
    {{ prefix }}
  </span>
  <span class="mat-title price-wrapper">
    <span [class.mr-1]="this.currency === CurrencyEnum.JPY">
      {{ valueProposition | customCurrencyPipe }}
    </span>
    <span *ngIf="customFromSymbol" class="custom-from-symbol">
      {{ customFromSymbol | translate }}
    </span>
  </span>
  <span class="suffix">{{ suffix }}</span>
</div>
